import { Component, OnDestroy, OnInit } from '@angular/core';
import { faBars, faEye, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { DownloadPopupComponent } from '../popup/download-popup/download-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { AircraftPopupComponent } from '../popup/aircraft-popup/aircraft-popup.component';
import { GroupsPopupComponent } from '../popup/groups-popup/groups-popup.component';
import { MessagesPopupComponent } from '../popup/messages-popup/messages-popup.component';
import { SessionQuery } from '../../store/session/state/session.query';
import { LoginPopupComponent } from '../popup/login-popup/login-popup.component';
import { SessionService } from '../../store/session/state/session.service';
import { SubSink } from 'subsink';
import { FollowingQuery } from 'src/app/store/following/state/following.query';
import { SessionStore } from '../../store/session/state/session.store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  faBars = faBars;
  faEye = faEye;
  faUser = faUser;
  faClose = faTimes;
  menuOpen = false;
  contactOpen = false;
  userOpen = false;
  mapOptionsOpen = false;
  userOptionsOpen = false;
  eyeIconState: 'map' | 'vehicles' | 'antenna' | 'following' | null;
  isLoggedIn = false;
  edit = false;
  passwordEdit = false;
  password = '';
  showPassword = false;
  subs = new SubSink();
  user = null;
  selectedVehiclePopupOpen: boolean;
  userForm = new FormBuilder().group({});

  constructor(
    private dialog: MatDialog,
    private sessionQuery: SessionQuery,
    private sessionService: SessionService,
    private sessionStore: SessionStore,
    private followingQuery: FollowingQuery,
    private snackbar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.subs.sink = this.sessionQuery
      .select()
      .subscribe((value) => (this.isLoggedIn = value.token !== null));
    this.subs.sink = this.followingQuery
      .select()
      .subscribe((x) => (this.selectedVehiclePopupOpen = !!x.currentVechile));
    this.subs.sink = this.sessionQuery.select('token').subscribe(_ => {
      // this.user = this.sessionService.getUser();
      this.userForm.setControl('name', new FormControl(this.user?.name, Validators.required));
      this.userForm.setControl('email', new FormControl(this.user?.email, Validators.required));
      this.userForm.setControl('phone', new FormControl(this.user?.phone));
    });
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    this.mapOptionsOpen = false;
    this.userOptionsOpen = false;
    this.contactOpen = false;
    this.userOpen = false;
  }

  toggleMapOptions(): void {
    this.mapOptionsOpen = !this.mapOptionsOpen;
    this.userOptionsOpen = false;
    this.menuOpen = false;
    this.contactOpen = false;
    this.userOpen = false;

  }

  toggleUserOptions(): void {
    this.userOptionsOpen = !this.userOptionsOpen;
    this.mapOptionsOpen = false;
    this.menuOpen = false;
    this.contactOpen = false;
    this.userOpen = false;
  }

  toggleUserDetails(): void {
    if (this.userOptionsOpen) {
      this.userOpen = !this.userOpen;
    }
  }

  toggleContact(): void {
    if (this.menuOpen) {
      this.contactOpen = !this.contactOpen;
    }
  }

  openDownloadPopup(): void {
    this.dialog.open(DownloadPopupComponent, {
      width: '500px'
    });
  }

  openAircraftPopup(): void {
    this.dialog.open(AircraftPopupComponent, {
      width: '520px'
    });
  }

  openGroupsPopup(): void {
    this.dialog.open(GroupsPopupComponent, {
      width: '520px',
      height: '450px'
    });
  }

  openMessagesPopup(): void {
    this.dialog.open(MessagesPopupComponent, {
      width: '500px',
      height: '550px'
    });
  }

  openLoginPopup(): void {
    this.dialog.open(LoginPopupComponent, {
      width: '300px'
      // height: '480px'
    });
  }

  onEyeElementClick(param: 'map' | 'vehicles' | 'antenna' | 'following' | null): void {
    if (this.eyeIconState === param) {
      this.eyeIconState = null;
    } else {
      this.eyeIconState = param;
    }
  }

  // savePassword(): void {
  //   this.user = {
  //     ...this.user = this.sessionService.getUser(), ...this.userForm.value
  //   };
  //   this.user.password = this.password;
  //   this.subs.sink = this.sessionService.postUser(this.user).subscribe(
  //     _ => {
  //       this.password = '';
  //       this.passwordEdit = false;
  //       this.snackbar.open('Jelszó módosítása sikeres!');
  //     },
  //     _ => this.snackbar.open('Jelszó módosítása sikertelen!')
  //   );
  //
  // }
  //
  // saveUser(): void {
  //   this.userForm.markAllAsTouched();
  //   if (this.userForm.valid) {
  //     this.user = {
  //       ...this.user = this.sessionService.getUser(), ...this.userForm.value
  //     };
  //     this.subs.sink = this.sessionService.postUser(this.user).subscribe(
  //       _ => {
  //         this.edit = false;
  //         this.snackbar.open('Adatok módosítása sikeres!');
  //       },
  //       _ => this.snackbar.open('Adatok módosítása sikertelen!')
  //     );
  //   }
  // }

  logout(): void {
    this.sessionService.logout();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
